__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "catalystzero-ui-cl";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fluentui/react-hooks", "8.8.16", () => (__webpack_require__.e(722).then(() => (() => (__webpack_require__(60722))))));
			register("@mds/mds-reactjs-library", "2.1.1", () => (Promise.all([__webpack_require__.e(1972), __webpack_require__.e(608), __webpack_require__.e(6869), __webpack_require__.e(9513), __webpack_require__.e(4620)]).then(() => (() => (__webpack_require__(79513))))));
			register("@tanstack/react-query", "5.62.3", () => (Promise.all([__webpack_require__.e(2333), __webpack_require__.e(4848)]).then(() => (() => (__webpack_require__(52333))))));
			register("@tanstack/react-virtual", "3.11.0", () => (__webpack_require__.e(2181).then(() => (() => (__webpack_require__(72181))))));
			register("axios", "1.7.9", () => (__webpack_require__.e(4447).then(() => (() => (__webpack_require__(84447))))));
			register("clsx", "1.2.1", () => (__webpack_require__.e(5128).then(() => (() => (__webpack_require__(25128))))));
			register("clsx", "2.1.1", () => (__webpack_require__.e(1783).then(() => (() => (__webpack_require__(34164))))));
			register("file-saver", "2.0.5", () => (__webpack_require__.e(4213).then(() => (() => (__webpack_require__(4213))))));
			register("html2canvas", "1.4.1", () => (__webpack_require__.e(354).then(() => (() => (__webpack_require__(20354))))));
			register("intersection-observer", "0.12.2", () => (__webpack_require__.e(5127).then(() => (() => (__webpack_require__(95127))))));
			register("luxon", "3.5.0", () => (__webpack_require__.e(6285).then(() => (() => (__webpack_require__(96285))))));
			register("pretty-bytes", "6.1.1", () => (__webpack_require__.e(2662).then(() => (() => (__webpack_require__(2662))))));
			register("qs", "6.13.1", () => (Promise.all([__webpack_require__.e(5373), __webpack_require__.e(2634)]).then(() => (() => (__webpack_require__(55373))))));
			register("rambda", "9.4.0", () => (__webpack_require__.e(2917).then(() => (() => (__webpack_require__(42917))))));
			register("react-datepicker", "4.8.0", () => (Promise.all([__webpack_require__.e(608), __webpack_require__.e(7726)]).then(() => (() => (__webpack_require__(97726))))));
			register("react-datepicker", "7.5.0", () => (Promise.all([__webpack_require__.e(9386), __webpack_require__.e(2843)]).then(() => (() => (__webpack_require__(59386))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(40961))), 1);
			register("react-hook-form", "7.54.0", () => (__webpack_require__.e(9785).then(() => (() => (__webpack_require__(49785))))));
			register("react-intersection-observer", "9.13.1", () => (__webpack_require__.e(5692).then(() => (() => (__webpack_require__(85692))))));
			register("react-intl", "7.0.4", () => (__webpack_require__.e(5019).then(() => (() => (__webpack_require__(85019))))));
			register("react-loading-skeleton", "3.5.0", () => (__webpack_require__.e(255).then(() => (() => (__webpack_require__(70255))))));
			register("react-modern-drawer", "1.4.0", () => (__webpack_require__.e(8202).then(() => (() => (__webpack_require__(98202))))));
			register("react-router-dom", "6.28.0", () => (() => (__webpack_require__(92648))), 1);
			register("react-use-error-boundary", "3.0.0", () => (__webpack_require__.e(5886).then(() => (() => (__webpack_require__(85886))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(96540))), 1);
			register("recharts", "2.14.1", () => (Promise.all([__webpack_require__.e(1972), __webpack_require__.e(6869), __webpack_require__.e(5700), __webpack_require__.e(5117), __webpack_require__.e(2843)]).then(() => (() => (__webpack_require__(35117))))));
			register("tiny-lru", "11.2.11", () => (__webpack_require__.e(5957).then(() => (() => (__webpack_require__(75957))))));
			register("victory", "37.3.3", () => (Promise.all([__webpack_require__.e(1972), __webpack_require__.e(5700), __webpack_require__.e(4559)]).then(() => (() => (__webpack_require__(84559))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};